let hopes = [
    {
      itemId : '20240304-06-A1',
      hopeNo : '20240304A1-1',
      hoper : 'user02',
      context : '아동용 크록스와 교환 원합니다.',
      writeDate : new Date(),
      updateDate : new Date(),
      status : '10',
      visibleYn : true
    },
    {
      itemId : '20240304-06-A1',
      hopeNo : '20240304A1-2',
      hoper : 'user03',
      context : '5세 유치원모자 리미티드 에디션이랑 어떠세요?',
      writeDate : new Date(),
      updateDate : new Date(),
      status : '40',
      visibleYn : true
    },
    {
      itemId : '20240304-06-A2',
      hopeNo : '20240304A2-1-1',
      hoper : 'user03',
      context : '올검정 운동화와 교환 신청합니다.',
      writeDate : new Date(),
      updateDate : new Date(),
      status : '10',
      visibleYn : true
    },
    {
      itemId : '20240304-06-A3',
      hopeNo : '20240304A3-1-1',
      hoper : 'user03',
      context : '교환 원합니다. 제 물건들 중 원하는거 말해주세요.',
      writeDate : new Date(),
      updateDate : new Date(),
      status : '10',
      visibleYn : true
    },
    {
      itemId : '20240304-06-A3',
      hopeNo : '20240304A3-2-1',
      hoper : 'user04',
      context : '1:2 물물교환 합시다.',
      writeDate : new Date(),
      updateDate : new Date(),
      status : '20',
      visibleYn : true
    },
    
  ];

  export default hopes;